<div class="max-w-[1200px] mx-auto px-6 pt-6 pb-20 relative z-10 animate-fade-in" *ngIf="token">
  
  <!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-[12px] font-bold text-text-muted mb-6">
    <a routerLink="/explore" class="hover:text-white transition-colors">Explore</a>
    <svg class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" /></svg>
    <span class="text-white">{{token.symbol}}</span>
  </div>

  <!-- Header -->
  <div class="flex flex-col mb-8 gap-4">
    <div class="flex items-start gap-4">
      <div class="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center font-black text-white text-[20px] md:text-[24px] relative overflow-hidden shadow-[0_0_20px_rgba(255,255,255,0.05)]" [style.backgroundColor]="token.color">
        {{token.symbol.substring(0, 1)}}
        <div class="absolute inset-0 bg-white/10 border border-white/20 rounded-full"></div>
      </div>
      <div class="flex flex-col items-start gap-1.5">
        <h1 class="text-[28px] md:text-[32px] font-black text-white flex items-center gap-2 leading-none">
          {{token.name}} <span class="text-text-muted text-[16px] md:text-[18px]">{{token.symbol}}</span>
        </h1>
        <div class="flex items-center gap-1.5 bg-[#0c0c0c] border border-white/10 rounded-full px-3 py-1 text-[11px] font-bold text-white cursor-pointer hover:bg-white/[0.05] transition-colors mt-1">
          <span class="w-2 h-2 rounded-full bg-[#627eea]"></span>
          All networks
          <svg class="w-3.5 h-3.5 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
    </div>
    
    <div class="flex items-center gap-3 mt-1">
      <button routerLink="/swap" class="bg-[#F5B73B] text-black px-6 py-2.5 rounded-xl text-[13px] font-black tracking-widest uppercase shadow-[0_0_15px_rgba(245,183,59,0.15)] hover:bg-[#e5a830] transition-colors">
         Swap
      </button>
      <button class="w-11 h-11 flex items-center justify-center rounded-xl bg-[#0c0c0c] border border-white/10 hover:bg-white/[0.05] hover:border-white/20 transition-all text-text-muted hover:text-white">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>
      </button>
    </div>
  </div>

  <div class="max-w-5xl mx-auto flex flex-col gap-10">
    
    <!-- Chart Area -->
    <div>
        <div class="mb-8">
          <div class="text-[42px] md:text-[48px] font-black text-white tracking-tight leading-none mb-3">${{token.price < 0.1 ? (token.price | number:'1.5-5') : (token.price | number:'1.2-2')}}</div>
          <div class="text-[14px] font-black flex items-center gap-1.5" [ngClass]="token.change1D >= 0 ? 'text-emerald-400' : 'text-red-400'">
            <svg class="w-4 h-4" *ngIf="token.change1D >= 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" /></svg>
            <svg class="w-4 h-4" *ngIf="token.change1D < 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>
            ${{(token.price * Math.abs(token.change1D / 100)) | number:'1.4-4'}} ({{token.change1D >= 0 ? token.change1D : -token.change1D | number:'1.2-2'}}%)
          </div>
        </div>

        <div class="h-[300px] w-full relative mb-4">
           <div #mainChart class="absolute inset-0"></div>
        </div>

        <div class="flex flex-col items-start gap-4 pt-6">
          <div class="flex flex-wrap items-center gap-2">
             <button *ngFor="let tf of timeframes" (click)="setTimeframe(tf)"
                [class.bg-white]="activeTimeframe === tf" [class.text-black]="activeTimeframe === tf" [class.shadow-md]="activeTimeframe === tf"
                [class.text-text-muted]="activeTimeframe !== tf" [class.hover:text-white]="activeTimeframe !== tf"
                class="px-3.5 py-1.5 rounded-[10px] text-[12px] font-black transition-all">
               {{tf}}
             </button>
          </div>
          <div class="flex flex-wrap items-center gap-4">
            <div class="flex items-center gap-1 bg-[#0c0c0c] border border-white/5 rounded-xl p-1">
               <button (click)="setChartType('line')" [class.bg-white]="chartType === 'line'" [class.text-black]="chartType === 'line'" [class.text-text-muted]="chartType !== 'line'" class="p-2 rounded-lg transition-colors">
                  <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" /></svg>
               </button>
               <button (click)="setChartType('bar')" [class.bg-white]="chartType === 'bar'" [class.text-black]="chartType === 'bar'" [class.text-text-muted]="chartType !== 'bar'" class="p-2 rounded-lg transition-colors">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M4 19h16v2H4v-2zm4-14h4v12H8V5zm-6 6h4v6H2v-6zm12-4h4v10h-4V7z"/></svg>
               </button>
            </div>
            <div class="flex items-center gap-1 text-[12px] font-black">
               <button class="bg-[#0c0c0c] border border-white/5 rounded-xl px-4 py-2 text-white transition-all">Price</button>
               <button class="px-4 py-2 text-text-muted hover:text-white transition-colors">Volume</button>
               <button class="px-4 py-2 text-text-muted hover:text-white transition-colors">TVL</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Stats Grid -->
      <div *ngIf="appState.tokenDetailStats() as stats" class="mt-4">
        <h3 class="text-[18px] font-black text-white mb-6">Stats</h3>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-y-8 gap-x-4">
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">TVL</span>
             <span class="text-white text-[20px] font-black">{{stats.tvl}}</span>
           </div>
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">Market cap</span>
             <span class="text-white text-[20px] font-black">{{stats.marketCap}}</span>
           </div>
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">FDV</span>
             <span class="text-white text-[20px] font-black">{{stats.fdv}}</span>
           </div>
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">1 day volume</span>
             <span class="text-white text-[20px] font-black">{{stats.volume1D}}</span>
           </div>
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">52W High</span>
             <span class="text-white text-[20px] font-black">{{stats.high52W}}</span>
           </div>
           <div class="flex flex-col">
             <span class="text-text-muted text-[11px] font-bold uppercase tracking-wider mb-1">52W Low</span>
             <span class="text-white text-[20px] font-black">{{stats.low52W}}</span>
           </div>
        </div>
      </div>

      <!-- About -->
      <div *ngIf="appState.tokenAbout() as about" class="mt-4">
        <h3 class="text-[18px] font-black text-white mb-4">About</h3>
        <p class="text-text-muted text-[13px] leading-relaxed mb-2">{{about.description}}</p>
        <button class="text-white font-bold text-[13px] hover:text-gold transition-colors mb-6">Show more</button>
        
        <div class="flex flex-wrap items-center gap-3">
           <button class="flex items-center gap-2 bg-[#0c0c0c] border border-white/10 rounded-xl px-4 py-2 text-[12px] font-bold text-white hover:border-white/20 hover:bg-white/[0.05] transition-all">
             <svg class="w-3.5 h-3.5 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>
             Address
           </button>
           <button class="flex items-center gap-2 bg-[#0c0c0c] border border-white/10 rounded-xl px-4 py-2 text-[12px] font-bold text-white hover:border-white/20 hover:bg-white/[0.05] transition-all">
             <svg class="w-3.5 h-3.5 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
             Explorer
           </button>
           <button class="flex items-center gap-2 bg-[#0c0c0c] border border-white/10 rounded-xl px-4 py-2 text-[12px] font-bold text-white hover:border-white/20 hover:bg-white/[0.05] transition-all">
             <svg class="w-3.5 h-3.5 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" /></svg>
             Website
           </button>
        </div>
      </div>

      <!-- Transactions / Pools -->
      <div class="mt-8">
        <div class="flex items-center gap-6 mb-6">
           <button *ngFor="let tab of tabs" (click)="setTab(tab)" [class.text-white]="activeTab === tab" [class.text-text-muted]="activeTab !== tab" class="text-[18px] font-black hover:text-white transition-colors">
             {{tab}}
           </button>
        </div>
        
        <div class="card rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl shadow-xl p-4 lg:p-0" *ngIf="activeTab === 'Transactions'">
           <table class="w-full text-left border-collapse block lg:table">
             <thead class="hidden lg:table-header-group">
               <tr class="text-text-muted text-[11px] font-bold uppercase tracking-wider border-b border-white/5">
                 <th class="py-3 px-2">Time</th>
                 <th class="py-3 px-2">Type</th>
                 <th class="py-3 px-2 text-right">${{token.symbol}}</th>
                 <th class="py-3 px-2 text-right">For</th>
                 <th class="py-3 px-2 text-right">USD</th>
                 <th class="py-3 px-2 text-right">Wallet</th>
               </tr>
             </thead>
             <tbody class="block lg:table-row-group text-[13px] font-bold">
               <tr *ngFor="let tx of appState.tokenTransactions()" class="block lg:table-row border border-white/5 lg:border-0 lg:border-b lg:border-white/5 hover:bg-white/[0.04] transition-colors cursor-pointer mb-4 lg:mb-0 p-4 lg:p-0 rounded-2xl lg:rounded-none bg-[#050505] lg:bg-transparent">
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 text-text-muted border-b border-white/5 lg:border-none">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">Time</span>
                    <span>{{tx.time}}</span>
                 </td>
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 border-b border-white/5 lg:border-none" [ngClass]="tx.type === 'Buy' ? 'text-emerald-400' : 'text-red-400'">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">Type</span>
                    <span>{{tx.type}}</span>
                 </td>
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 text-right text-white border-b border-white/5 lg:border-none">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">Amount</span>
                    <span>{{tx.tokenAmount | number:'1.2-2'}}</span>
                 </td>
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 text-right text-white border-b border-white/5 lg:border-none">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">For</span>
                    <div class="flex items-center justify-end gap-1.5">
                       {{tx.forAmount < 1 ? (tx.forAmount | number:'1.2-2') : (tx.forAmount | number:'1.2-2')}} {{tx.forSymbol}}
                       <div class="w-4 h-4 rounded-full bg-white/10 flex items-center justify-center text-[6px] uppercase">{{tx.forSymbol.substring(0,2)}}</div>
                    </div>
                 </td>
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 text-right text-white border-b border-white/5 lg:border-none">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">USD</span>
                    <span>{{tx.usdValue}}</span>
                 </td>
                 <td class="flex lg:table-cell justify-between items-center py-2.5 lg:py-4 px-0 lg:px-4 text-right text-text-dim hover:text-gold cursor-pointer transition-colors">
                    <span class="lg:hidden text-[11px] font-bold uppercase text-text-muted">Wallet</span>
                    <span>{{tx.wallet}}</span>
                 </td>
               </tr>
             </tbody>
           </table>
           <div class="flex justify-center border-t border-white/[0.05] py-5">
             <button class="text-[12px] font-bold text-text-muted hover:text-white transition-colors flex items-center gap-2">Load more</button>
           </div>
        </div>
      </div>

  </div>

</div>
